import React from 'react'

function CmsCourseView() {
  return (
    <div>CmsCourseView</div>
  )
}

export default CmsCourseView